var _defs, _g, _path, _path2, _path3, _path4, _path5, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInicioa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    zoomAndPan: "magnify",
    viewBox: "0 0 96 95.999999",
    height: 128,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8f614e6a4a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 66 22 L 81.179688 22 L 81.179688 36 L 66 36 Z M 66 22 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d934f3d76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.179688 10 L 37 10 L 37 96 L 15.179688 96 Z M 15.179688 10 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8f614e6a4a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M 66.933594 22.925781 C 67.699219 26.621094 68.464844 30.316406 69.230469 34.007812 C 72.996094 33.339844 76.9375 33.535156 81.183594 35.179688 C 80.417969 31.484375 79.652344 27.789062 78.886719 24.097656 C 74.640625 22.453125 70.695312 22.253906 66.933594 22.925781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M 47.84375 43.824219 C 51.367188 41.996094 54.832031 39.878906 58.355469 38.050781 C 57.589844 34.355469 56.824219 30.660156 56.058594 26.96875 C 52.535156 28.796875 49.070312 30.914062 45.546875 32.746094 C 46.3125 36.4375 47.078125 40.132812 47.84375 43.824219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M 32.355469 25.613281 C 33.128906 29.339844 33.902344 33.0625 34.675781 36.785156 C 38.4375 36.113281 42.023438 34.574219 45.546875 32.746094 C 44.773438 29.019531 44.003906 25.296875 43.230469 21.574219 C 39.707031 23.402344 36.121094 24.941406 32.355469 25.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M 51.445312 4.714844 C 47.921875 6.542969 44.457031 8.660156 40.933594 10.492188 C 41.699219 14.183594 42.464844 17.878906 43.230469 21.574219 C 46.753906 19.742188 50.21875 17.625 53.742188 15.792969 C 52.976562 12.101562 52.210938 8.410156 51.445312 4.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M 53.742188 15.796875 C 54.515625 19.519531 55.289062 23.242188 56.058594 26.96875 C 59.582031 25.136719 63.167969 23.597656 66.933594 22.925781 C 66.160156 19.203125 65.386719 15.476562 64.617188 11.753906 C 60.851562 12.425781 57.265625 13.964844 53.742188 15.796875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M 76.570312 12.925781 C 75.804688 9.230469 75.039062 5.539062 74.273438 1.84375 C 70.027344 0.199219 66.082031 0.00390625 62.320312 0.675781 C 63.085938 4.367188 63.851562 8.0625 64.617188 11.753906 C 68.378906 11.082031 72.324219 11.28125 76.570312 12.925781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d934f3d76)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M 23.074219 35.746094 L 20.757812 24.574219 C 24.867188 26.09375 28.699219 26.265625 32.355469 25.613281 C 31.589844 21.917969 30.824219 18.226562 30.058594 14.53125 C 26.398438 15.183594 22.570312 15.011719 18.460938 13.492188 L 17.96875 11.128906 C 17.820312 10.40625 17.105469 9.9375 16.378906 10.089844 C 15.648438 10.238281 15.179688 10.949219 15.332031 11.671875 L 32.566406 94.804688 C 32.71875 95.527344 33.429688 95.996094 34.160156 95.84375 C 34.886719 95.695312 35.355469 94.984375 35.207031 94.261719 L 25.371094 46.828125 C 29.480469 48.347656 33.3125 48.515625 36.972656 47.863281 C 36.207031 44.171875 35.441406 40.480469 34.675781 36.785156 C 31.015625 37.4375 27.183594 37.265625 23.074219 35.746094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInicioa);
export default __webpack_public_path__ + "static/media/inicio.a.a199c7d6a8b341224519dd28da9c1eff.svg";
export { ForwardRef as ReactComponent };